import { render } from "./BayActivation.vue?vue&type=template&id=0820e8f6&scoped=true"
import script from "./BayActivation.vue?vue&type=script&lang=js"
export * from "./BayActivation.vue?vue&type=script&lang=js"

import "./BayActivation.vue?vue&type=style&index=0&id=0820e8f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0820e8f6"]])

export default __exports__